export const addToCart = async (productId) => {
  try {
    const response = await fetch(
      window.siteUrl + "/wp-json/custom/v1/add-to-cart/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_id: productId, quantity: 1 }),
      }
    );
    const data = await response.json();
    if (data.status === "success") {
      window.location.href = window.siteUrl + "/checkout";
    } else {
      console.error("Failed to add to cart: ", data);
    }
  } catch (error) {
    console.error("Error adding to cart: ", error);
  }
};

export const linkFree = () => {
  window.location.href =
    "https://wordpress.org/plugins/whizmanage/";
};

export const tiers = [
  {
    name: "Basic",
    id: "tier-free",
    href: "link-to-free-download",
    priceYearly: "$0",
    monthlyNote: "Free Forever",
    description:
      "Full-featured store management.\nPerfect for single-site owners.",
    sitesBadge: "1 Site",
    features: [
      "Advanced Products Table",
      "Inline & Popup Editing",
      "Smart Media Manager",
      "Rich Text Editor",
      "Drag & Drop Columns",
      "Custom Column Views",
      "Advanced Filters & Search",
      "Coupon Management",
      "Activity History",
      "Light & Dark Themes",
    ],
    featured: false,
    cta: "Download Free",
    onClick: linkFree,
  },
  {
    name: "Popular",
    id: "tier-popular",
    href: "#",
    productId: 1284,
    priceYearly: "$129.84/yr",
    monthlyNote: "(≈ $10.82/mo)",
    description: "Everything in Basic, plus power tools.",
    sitesBadge: "1 Site",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: true,
    cta: "Buy Now",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(1284);
      } else {
        setShowLoginModal(true);
        setProductId(1284);
      }
    },
  },
  {
    name: "Pro",
    id: "tier-pro",
    href: "#",
    productId: 2407,
    priceYearly: "$519.9/yr",
    monthlyNote: "(≈ $43.33/mo)",
    description: "Everything in Basic, plus power tools.",
    sitesBadge: "3 Sites",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: false,
    cta: "Buy Now",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(2407);
      } else {
        setShowLoginModal(true);
        setProductId(2407);
      }
    },
  },
  {
    name: "Expert",
    id: "tier-expert",
    href: "#",
    productId: 1749,
    priceYearly: "$779.88/yr",
    monthlyNote: "(≈ $64.99/mo)",
    description: "Everything in Basic, plus power tools.",
    sitesBadge: "10 Sites",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: false,
    cta: "Buy Now",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(1749);
      } else {
        setShowLoginModal(true);
        setProductId(1749);
      }
    },
  },
];

export const heTiers = [
  {
    name: "בסיסי",
    id: "tier-free",
    href: "link-to-free-download",
    priceYearly: "$0",
    monthlyNote: "חינם לתמיד",
    description: "ניהול חנות מלא לבעלי אתר בודד.",
    sitesBadge: "אתר 1",
    features: [
      "טבלת מוצרים מתקדמת",
      "עריכה ישירה ובחלונית",
      "מנהל מדיה חכם",
      "עורך טקסט עשיר",
      "גרירת עמודות",
      "תצוגות עמודות מותאמות",
      "סינון וחיפוש מתקדם",
      "ניהול קופונים",
      "היסטוריית פעולות",
      "ערכות עיצוב בהיר וכהה",
    ],
    featured: false,
    cta: "הורדה חינם",
    onClick: linkFree,
  },
  {
    name: "פופולרי",
    id: "tier-popular",
    href: "#",
    productId: 1284,
    priceYearly: "$129.84/שנה",
    monthlyNote: "(≈ $10.82/חודש)",
    description: "כל מה שבבסיסי, פלוס כלים מתקדמים.",
    sitesBadge: "אתר 1",
    features: [
      {
        text: "סנכרון Google Sheets",
        badge: "פיצ'ר מבוקש",
      },
      "הוספת שורות מהירה בטבלה",
      "ניהול וריאציות חכם",
      "כלי עריכה כמותית",
      "עריכת תגיות וקטגוריות ישירה",
      "שכפול בלחיצה אחת",
      { text: "מנוע חוקי הנחות", badge: "חדש" },
      { text: "ניהול הזמנות", badge: "חדש" },
      { text: "ניהול לקוחות", badge: "חדש" },
    ],
    featured: true,
    cta: "קנה עכשיו",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(1284);
      } else {
        setShowLoginModal(true);
        setProductId(1284);
      }
    },
  },
  {
    name: "מקצועי",
    id: "tier-pro",
    href: "#",
    productId: 2407,
    priceYearly: "$519.9/שנה",
    monthlyNote: "(≈ $43.33/חודש)",
    description: "כל מה שבבסיסי, פלוס כלים מתקדמים.",
    sitesBadge: "3 אתרים",
    features: [
      {
        text: "סנכרון Google Sheets",
        badge: "פיצ'ר מבוקש",
      },
      "הוספת שורות מהירה בטבלה",
      "ניהול וריאציות חכם",
      "כלי עריכה כמותית",
      "עריכת תגיות וקטגוריות ישירה",
      "שכפול בלחיצה אחת",
      { text: "מנוע חוקי הנחות", badge: "חדש" },
      { text: "ניהול הזמנות", badge: "חדש" },
      { text: "ניהול לקוחות", badge: "חדש" },
    ],
    featured: false,
    cta: "קנה עכשיו",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(2407);
      } else {
        setShowLoginModal(true);
        setProductId(2407);
      }
    },
  },
  {
    name: "מומחה",
    id: "tier-expert",
    href: "#",
    productId: 1749,
    priceYearly: "$779.88/שנה",
    monthlyNote: "(≈ $64.99/חודש)",
    description: "כל מה שבבסיסי, פלוס כלים מתקדמים.",
    sitesBadge: "10 אתרים",
    features: [
      {
        text: "סנכרון Google Sheets",
        badge: "פיצ'ר מבוקש",
      },
      "הוספת שורות מהירה בטבלה",
      "ניהול וריאציות חכם",
      "כלי עריכה כמותית",
      "עריכת תגיות וקטגוריות ישירה",
      "שכפול בלחיצה אחת",
      { text: "מנוע חוקי הנחות", badge: "חדש" },
      { text: "ניהול הזמנות", badge: "חדש" },
      { text: "ניהול לקוחות", badge: "חדש" },
    ],
    featured: false,
    cta: "קנה עכשיו",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(1749);
      } else {
        setShowLoginModal(true);
        setProductId(1749);
      }
    },
  },
];

export const lifetime1Tier = [
  {
    name: "Lifetime Single",
    id: "tier-lifetime-single",
    href: "#",
    productId: 3498,
    price: "$500",
    description: "Perfect for single site owners - lifetime access.",
    sitesBadge: "1 Site - Lifetime",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: true,
    cta: "Get Lifetime Access",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(3498);
      } else {
        setShowLoginModal(true);
        setProductId(3498);
      }
    },
  },
];

export const lifetimeTiers = [
  {
    name: "Lifetime Popular",
    id: "tier-lifetime-popular",
    href: "#",
    productId: 3099,
    price: "$300",
    description: "Perfect for small businesses - lifetime access.",
    sitesBadge: "5 Sites - Lifetime",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: true,
    cta: "Get Lifetime Access",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(3099);
      } else {
        setShowLoginModal(true);
        setProductId(3099);
      }
    },
  },
  {
    name: "Lifetime Pro",
    id: "tier-lifetime-pro",
    href: "#",
    productId: 3106,
    price: "$500",
    description: "Great for managing multiple sites - lifetime access.",
    sitesBadge: "10 Sites - Lifetime",
    features: [
      {
        text: "Google Sheets Sync",
        badge: "Most Requested",
      },
      "Quick-Add Table Rows",
      "Smart Variations Manager",
      "Bulk Edit Tools",
      "Inline Taxonomy Editing",
      "One-Click Duplication",
      { text: "Discount Rules", badge: "New" },
      { text: "Orders Manager", badge: "New" },
      { text: "Customers Manager", badge: "New" },
    ],
    featured: false,
    cta: "Get Lifetime Access",
    onClick: (setShowLoginModal, setProductId) => {
      if (window.isLogin) {
        addToCart(3106);
      } else {
        setShowLoginModal(true);
        setProductId(3106);
      }
    },
  },
];
